import {useDispatch, useSelector} from "react-redux";
import {fetchPublications, selectPublication} from "../redux/slices/publication";

const usePublications = () => {
    const {list, loading, isInitialized} = useSelector(selectPublication);
    const dispatch = useDispatch();

    const reset = () => dispatch(fetchPublications({}))

    const loadMore = () => dispatch(fetchPublications({loadMore: true}))

    !loading && !isInitialized && loadMore();

    return {list, loading, loadMore, reset};
}

export default usePublications;